import { Question, SurveyModel } from "survey-core";
import { SurveyQuestionElementBase } from "survey-react-ui";

import { DefaultButton, Heading, Link, Stack } from "@bps/fluent-ui";

import { registerWidget } from "./registerWidget";

const QUESTION_TYPE = "bpPageButtons";

// A model for the new question type
export class CustomPageButtonsModel extends Question {
  constructor(props: string) {
    super(props);
    this.choices = [];
  }

  getType() {
    return QUESTION_TYPE;
  }

  get choices() {
    return this.getPropertyValue("choices");
  }

  set choices(val) {
    this.setPropertyValue("choices", val);
  }

  get bpTitle() {
    return this.getPropertyValue("bpTitle");
  }

  set bpTitle(val) {
    this.setPropertyValue("bpTitle", val);
  }
}

class PageButtonsQuestion extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.state = { value: this.question.value };
    this.survey = props.question.survey;
  }

  survey: SurveyModel;

  get options() {
    const c = this.question.fetchUrl ? [] : this.question.choices ?? [];
    return c?.map((c: any) => {
      return { key: c.value, value: c.value, name: c.value };
    });
  }

  get question() {
    return this.questionBase as CustomPageButtonsModel;
  }

  get value() {
    return this.question.value;
  }

  // Retrieve an option object based on the question value
  get selectedOption() {
    const res = [];
    const opts = this.options;
    let qValue = this.question.value;
    if (!qValue) qValue = [];

    for (let i = 0; i < opts.length; i++) {
      if (qValue.indexOf(opts[i].value) > -1) res.push(opts[i]);
    }
    return res;
  }

  // Set the question value to the selected option value
  onSelectChange = (items?: any[]) => {
    if (this.survey.currentPageNo === this.survey.pageCount - 1) {
      this.survey.doComplete();
    } else {
      this.survey.nextPage();
    }
    this.question.value = items;
  };

  renderElement = () => {
    const buttonStyles = {
      root: { minWidth: "min(calc(50vw - 24px), 218px)" }
    };
    return (
      <Stack tokens={{ childrenGap: 16 }} horizontalAlign="center">
        <Heading>{this.question.bpTitle}</Heading>
        <Stack
          horizontal
          horizontalAlign="start"
          styles={{ root: { marginTop: 20, maxWidth: 500 } }}
          tokens={{ childrenGap: 8 }}
        >
          <DefaultButton
            primary
            styles={buttonStyles}
            onClick={() =>
              this.onSelectChange([this.options[0].key.toString()])
            }
          >
            {this.options[0].name}
          </DefaultButton>
          <DefaultButton
            primary
            styles={buttonStyles}
            onClick={() =>
              this.onSelectChange([this.options[1].key.toString()])
            }
          >
            {this.options[1].name}
          </DefaultButton>
        </Stack>
        {this.survey.currentPageNo !== 0 && (
          <Link
            onClick={() => this.survey.prevPage()}
            iconProps={{ iconName: "Back" }}
          >
            Back
          </Link>
        )}
      </Stack>
    );
  };
}

export const registerPageButtons = () =>
  registerWidget({
    baseQuestion: "Dropdown",
    newQuestionName: QUESTION_TYPE,
    renderer: PageButtonsQuestion,
    newModelFn: name => new CustomPageButtonsModel(name),
    newToolboxItem: {
      name: QUESTION_TYPE,
      title: "Buttons (Moves page)",
      elementsJSON: {
        choices: [],
        value: [],
        bpTitle: "",
        visible: true
      }
    },
    extraProperties: [
      {
        name: "choices:itemValue[]",
        category: "general",
        visibleIndex: 3
      },
      {
        name: "bpTitle:string",
        category: "general",
        visibleIndex: 4
      }
    ]
  });
